<script>
  import { fade } from 'svelte/transition';
  import { playerState, streamState } from '../js/state.js';
  import {
    requestFullscreen,
    requestPlayVideo,
    requestPauseVideo,
    requestSoundMutedVideo,
    requestSoundSetLevel,
    requestSoundOnVideo,
    requestJumpToPosition,
    setPositionState,
  } from '../js/actions.js';
  import {
    PLAYER_STATE_PLAYING,
    PLAYER_STATE_SOUND_MUTED,
    STREAM_TYPE_VOD,
  } from '../js/constants.js';
  import Cookies from 'js-cookie';
  import Scrubber from './Scrubber.svelte';
  import Button from './player/Button.svelte';
  import VolumeSlider from './player/VolumeSlider.svelte';

  export let duration = 0,
    position = 0,
    hlsClient = null,
    volume = 1;

  const subtitleCookie = `${$streamState.source}_${$streamState.event_id}_subtitle`;
  let showSubtitleMenu = false;

  function toggleSubtitleMenu() {
    showSubtitleMenu = !showSubtitleMenu;
  }

  function setSubtitleCookie() {
    setTimeout(function() {
      if (!hlsClient || isNaN(hlsClient.subtitleTrack)) return;

      const path = document.location.pathname
        .split('/')
        .slice(0, 4)
        .join('/');
      Cookies.set(subtitleCookie, hlsClient.subtitleTrack, {
        sameSite: 'strict',
        path: path,
        secure: true,
      });
    }, 100);
  }

  function handleVolumeChange(e) {
    requestSoundSetLevel(e.detail.value);
  }

  $: setPositionState(position);
</script>

{#if $playerState.controls}
  <div class="container-fluid video-controls">
    {#if $streamState.type === STREAM_TYPE_VOD}
      <div class="row no-gutters">
        <div class="col">
          <Scrubber onscrub={requestJumpToPosition} current={position} max={duration} />
        </div>
      </div>
    {/if}

    <div class="row no-gutters">
      <div class="col" out:fade>
        {#if $playerState.state === PLAYER_STATE_PLAYING}
          <Button position="left" onClick={requestPauseVideo} icon="pause" />
        {:else}
          <Button position="left" onClick={requestPlayVideo} icon="play_arrow" />
        {/if}

        <div class="control control-expandable control-left">
          {#if $playerState.sound === PLAYER_STATE_SOUND_MUTED}
            <Button position="left" onClick={requestSoundOnVideo} icon="volume_off" />
          {:else}
            <Button position="left" onClick={requestSoundMutedVideo} icon="volume_up" />
          {/if}
          <VolumeSlider current={volume} on:change={handleVolumeChange} />
        </div>

        <Button position="right" onClick={requestFullscreen} icon="fullscreen" />

        {#if hlsClient.subtitleTracks && hlsClient.subtitleTracks.length > 0}
          {#if hlsClient.subtitleTrack > -1}
            <Button position="right" onClick={toggleSubtitleMenu} icon="closed_caption" />
          {:else}
            <Button position="right" onClick={toggleSubtitleMenu} icon="closed_caption_off" />
          {/if}

          {#if showSubtitleMenu}
            <div class="subtitle-picker">
              {#each hlsClient.subtitleTracks as track, i}
                <label for={`subtitle-track-${i}-radio`}>
                  <input
                    id={`subtitle-track-${i}-radio`}
                    type="radio"
                    bind:group={hlsClient.subtitleTrack}
                    on:change={setSubtitleCookie}
                    value={i} />
                  {track.name}
                </label>
              {/each}

              <label for="subtitle-track-input">
                <input
                  id="subtitle-track-input"
                  type="radio"
                  bind:group={hlsClient.subtitleTrack}
                  on:change={setSubtitleCookie}
                  value={-1} />
                Off
              </label>
            </div>
          {/if}
        {/if}
      </div>
    </div>
  </div>
{/if}
